import { GenericTableModel } from "libs/cv.invision-views.ux/src/lib/generic-crud-table/model/generic-table.model";
import { newConfigurationBlockFormBuilderConfig } from "./outgoing-form-builder-config.model";
// outgoing-events-table.model.ts
export class OutgoingEventsTableConfig extends GenericTableModel {
	constructor() {
		super();
		this.title = 'Outgoing Events';
		this.globalFilters = false;
		this.hasAddButton = false;
		this.hasCustomActions = false;
		this.hasDeleteAction = false;
		this.resultKey = null;
		this.stringKey = 'name';
		this.hasTabs = true;
		this.isCustomRecordData = true;
		this.createCustomUrl = (baseUrl, parameter) => {
			return `${baseUrl}/${parameter}/outgoing-events`;
		};
		this.extraParams = {
			limit: 1000
		};
		this.tabsConfiguration = [
			{
				title: 'Product Hybrid',
				subtitle: 'Outgoing Events',
				items: [
					{
						path: 'product'
					}
				]
			},
			{
				title: 'Product Hybrid (Sibling)',
				subtitle: 'Outgoing Events',
				items: [
					{
						path: 'productHybrid'
					}
				]
			},
			{
				title: 'Product Non-Hybrid',
				subtitle: 'Outgoing Events',
				items: [
					{
						path: 'productNonHybrid'
					}
				]
			}
		];
	}
}

export const OutgoingEventsModel = [
	{
		label: 'Integration Name',
		key: 'name'
	}
]

export const OutgoingEvents = {
	formBuilderConfig: newConfigurationBlockFormBuilderConfig
}
